if (!customElements.get('aka-featured-carousel')) {
  customElements.define('aka-featured-carousel', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const slider = this.querySelector('[id^="Slider-"]');
      if (!slider) return;
      const cards = [...slider.querySelectorAll(':scope > [id^="Slide-"]')];
      const queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = undefined;
          if (!this.isConnected || !slider.clientWidth) return;
          const viewport = slider.getBoundingClientRect();
          const visible = cards.filter(card => {
            const bounds = card.getBoundingClientRect();
            const center = bounds.left + bounds.width / 2;
            return center >= viewport.left && center <= viewport.right;
          });
          if (!visible.length) return;
          const styles = getComputedStyle(slider);
          const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
          const height = Math.ceil(Math.max(...visible.map(card => card.getBoundingClientRect().height)) + padding);
          const centers = visible.map(card => {
            const media = card.querySelector('.card__inner');
            if (!media) return 44;
            const bounds = media.getBoundingClientRect();
            return parseFloat(styles.paddingTop) + bounds.top - card.getBoundingClientRect().top + bounds.height / 2;
          });
          this.style.setProperty('--aka-visible-carousel-height', height + 'px');
          this.style.setProperty('--aka-carousel-arrow-center', Math.ceil(Math.max(22, ...centers)) + 'px');
        });
      };
      slider.addEventListener('scroll', queue, { passive: true, signal: this.events.signal });
      this.observer = new ResizeObserver(queue);
      this.observer.observe(slider);
      for (const card of cards) this.observer.observe(card);
      for (const image of slider.querySelectorAll('img')) image.addEventListener('load', queue, { signal: this.events.signal });
      document.fonts?.ready.then(queue);
      queue();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = undefined;
    }
  });
}
